<script lang="ts">
    import { slide } from 'svelte/transition'
    import type { Section } from '../../types/Section'
    import type { State } from '../../types/State'
    import type { Stats } from '../../types/Stats'
    import { StatsCollector } from '../../util/StatsCollector'
    import StatsBar from '../StatsBar.svelte'

    export let path: [number, number]

    export let section: Section

    export let state: State

    let stats: Stats | null = null

    $: stats = StatsCollector.collect(state, [...path])
</script>

<div class="description" transition:slide>
    <div class="number">{path[0] + 1}.{path[1] + 1}</div>
    <div class="text">{section.description}</div>
</div>
<div class="stats" transition:slide>
    {#if stats}
        <StatsBar {stats} size="large" />
    {/if}
</div>

<style lang="scss">
    .description {
        display: flex;
        column-gap: 1rem;

        .number {
            font-size: 1.5rem;
            color: var(--color-primary);
        }

        .text {
            width: 100%;
            font-size: 1rem;
        }
    }
</style>
